import moment from "moment";

export const documentCreationStatusesEnum = {
    All: "all",
    Created: "created",
    Missing: "missing",
};

export const documentCreationStatuses = [
    { label: "Все", value: documentCreationStatusesEnum.All },
    { label: "Документ создан", value: documentCreationStatusesEnum.Created },
    { label: "Документ не создан", value: documentCreationStatusesEnum.Missing },
];

const defaultDocumentListPeriod = () => ({
    startedAt: moment().startOf("month").toISOString(),
    endedAt: moment().toISOString(),
});

export const normalizeDocumentListParams = ({
    startedAt,
    endedAt,
    documentCreationStatus,
}: {
    startedAt?: string;
    endedAt?: string;
    documentCreationStatus?: string;
}) => {
    const defaultPeriod = defaultDocumentListPeriod();

    return {
        startedAt: startedAt || defaultPeriod.startedAt,
        endedAt: endedAt || defaultPeriod.endedAt,
        documentCreationStatus: Object.values(documentCreationStatusesEnum).includes(documentCreationStatus || "")
            ? documentCreationStatus
            : documentCreationStatusesEnum.All,
    };
};

export const filterByDocumentCreationStatus = <T extends { documentExists?: boolean }>(
    items: T[],
    documentCreationStatus?: string,
) => {
    switch (documentCreationStatus) {
        case documentCreationStatusesEnum.Created:
            return items.filter((item) => item.documentExists);
        case documentCreationStatusesEnum.Missing:
            return items.filter((item) => !item.documentExists);
        default:
            return items;
    }
};
